import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import Image from "@components/item/Image";
import SwiperContainer from "@components/swiper/SwiperContainer";
import { SwiperSlide } from "swiper/react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FilterContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "560px",
});

const FilterWrapper = styled.div({
  display: "flex",
  alignItems: "center",
  gap: "2rem !important",
  maxWidth: "560px",
  padding: "0 2rem",
  ".swiper-wrapper": {
    gap: "1rem !important",
  },
});

const FilterButton = styled(SwiperSlide)<{ focus: boolean }>(
  ({ theme, focus }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    color: focus ? theme.color.white : theme.color.black,
    background: focus ? theme.color.black : theme.color.white,
    border: "1px solid",
    padding: "0.8rem 1.2rem",
    borderRadius: "4px",
    gap: "0.4rem",
    whiteSpace: "nowrap",
    // width: "auto !important",
  }),
);

const CategoryFilterBar = ({
  setStep,
}: {
  setStep: (step: number) => void;
}) => {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const filterComponents = [
    { key: 1, label: t("필터") },
    { key: 2, label: t("정렬") },
    { key: 3, label: t("브랜드") },
    { key: 4, label: t("컨디션") },
    { key: 5, label: t("컬러") },
    { key: 6, label: t("무료배송") },
  ];

  // 선택된 값
  const checkFilterFocus = (filterKey: number) => {
    const params = {
      2: "order_by",
      3: "brand_id",
      4: "product_condition",
      5: "color_id",
      6: "is_free_shipping",
    }[filterKey];
    if (params === "is_free_shipping") {
      const value = searchParams.get(params);
      return value !== null && value !== "0"; // 0이 아닐 때만 true 반환
    }
    return params ? searchParams.get(params) !== null : false;
  };

  return (
    <FilterContainer>
      <FilterWrapper>
        <SwiperContainer perView={4}>
          {filterComponents.map((filter) => (
            <FilterButton
              key={filter.key}
              onClick={() => setStep(filter.key)} // 버튼 클릭 시 setStep 호출
              focus={checkFilterFocus(filter.key)}>
              {filter.label}
              {filter.key === 1 ? (
                <Image
                  width="1.6rem"
                  height="1.6rem"
                  fit="contain"
                  src={theme.image.filter_icon.default}
                />
              ) : (
                <Image
                  src={
                    checkFilterFocus(filter.key)
                      ? theme.image.arrow_down_white.default
                      : theme.image.arrow_down_black.default
                  }
                  size="1.6rem"
                />
              )}
            </FilterButton>
          ))}
        </SwiperContainer>
      </FilterWrapper>
    </FilterContainer>
  );
};

export default CategoryFilterBar;
